import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/data-not-found.svg'
import _imports_1 from '@/app/ui/assets/svg/no-notif.svg'


const _hoisted_1 = { class: "flex flex-col font-montserrat" }
const _hoisted_2 = { class: "flex flex-col bg-white" }
const _hoisted_3 = { class: "flex flex-col mx-auto w-full lg:w-700px xxl:w-1100px h-screen overflow-y-auto" }
const _hoisted_4 = { class: "flex flex-col gap-1 py-4 md:gap-0 md:flex-row md:py-6" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "w-full h-screen pb-64 justify-center items-center flex flex-col mx-auto py-20 text-12px xxl:text-14px overflow-hidden"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  key: 0,
  class: "w-full h-screen pb-64 bg-white justify-center items-center flex flex-col mx-auto py-20 text-12px xxl:text-14px overflow-hidden"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-32 mt-8 mx-auto",
  alt: "not_found"
}, null, -1)
const _hoisted_10 = { class: "text-gray-lp-300 py-2 font-semibold" }
const _hoisted_11 = { class: "text-12px xxl:text-14px text-gray-lp-600 font-normal" }
const _hoisted_12 = {
  key: 1,
  class: "w-full h-screen pb-64 bg-white justify-center items-center flex flex-col mx-auto py-20 text-12px xxl:text-14px overflow-hidden"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-32 mt-8 mx-auto",
  alt: "no_notif"
}, null, -1)
const _hoisted_14 = { class: "text-12px xxl:text-14px text-gray-lp-800 font-normal py-2" }
const _hoisted_15 = {
  key: 3,
  class: "flex flex-col overflow-auto h-screen pb-64 w-full"
}
const _hoisted_16 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_17 = { class: "py-0" }
const _hoisted_18 = { class: "text-gray-lp-300 text-12px xxl:text-14px px-2 font-medium bg-gray-lp-200 rounded inline-flex" }
const _hoisted_19 = { class: "flex flex-row overflow-auto py-4 w-full" }
const _hoisted_20 = { class: "flex flex-col h-full mr-4" }
const _hoisted_21 = { class: "w-6 mr-2 self-center mb-1 sm:mb-0 sm:self-auto" }
const _hoisted_22 = { class: "flex flex-col text-12px xxl:text-14px w-full" }
const _hoisted_23 = { class: "text-gray-lp-300" }
const _hoisted_24 = { class: "font-semibold" }
const _hoisted_25 = { class: "text-gray-lp-500 whitespace-no-wrap py-1" }
const _hoisted_26 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_27 = { class: "flex flex-col w-full pb-4" }
const _hoisted_28 = { class: "px-6 py-2 text-12px text-gray-lp-500" }
const _hoisted_29 = { class: "w-6 mr-2" }
const _hoisted_30 = { class: "flex flex-col text-12px w-full" }
const _hoisted_31 = { class: "flex flex-row justify-between" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "font-semibold mx-1" }
const _hoisted_34 = { class: "text-gray-lp-500 font-semibold" }
const _hoisted_35 = { class: "flex gap-4 mt-2" }
const _hoisted_36 = { class: "w-3.5 h-3.5 rounded-full bg-white flex items-center justify-center" }
const _hoisted_37 = { class: "text-gray-lp-200 font-semibold" }
const _hoisted_38 = { class: "text-gray-lp-200 font-semibold" }
const _hoisted_39 = {
  key: 1,
  class: "text-gray-lp-300 text-12px xxl:text-14px mr-6"
}
const _hoisted_40 = { class: "font-semibold" }
const _hoisted_41 = { class: "text-gray-lp-500 whitespace-no-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Search = _resolveComponent("Search")!
  const _component_Select = _resolveComponent("Select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_splide_slide = _resolveComponent("splide-slide")!
  const _component_splide = _resolveComponent("splide")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_infinite_scroll = _resolveComponent("infinite-scroll")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Header, {
        currentRoutes: _ctx.getCurrentRoute()
      }, null, 8, ["currentRoutes"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Search, {
          onInput: _ctx.onSearch,
          onClear: _ctx.onClearSearch,
          value: _ctx.searchValue,
          placeholder: _ctx.$t('notification.searchPlaceholder'),
          class: "mr-4 w-full md:w-2/3"
        }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
        _createVNode(_component_Select, {
          dataSelect: _ctx.filterData,
          onOpenSelect: _ctx.onOpenFilterSelect,
          onCloseSelect: _ctx.onCloseFilterSelect,
          onChooseSelect: _ctx.onSelectFilter,
          value: _ctx.filterValue,
          isOpenMenu: _ctx.filterSelect,
          class: "w-full md:w-1/3 filter_data",
          isDisabled: !_ctx.isNotificationsExist
        }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu", "isDisabled"])
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock("h1", _hoisted_5, _toDisplayString(_ctx.$t("notification.loading")), 1))
        : _createCommentVNode("", true),
      (_ctx.isError && !_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode(_component_ErrorMessage, {
              errorType: _ctx.isError ? _ctx.errorCause : 'notfound',
              onTryAgain: _ctx.isError && _ctx.onReload
            }, null, 8, ["errorType", "onTryAgain"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isLoading && !_ctx.isError)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            (!_ctx.isNotificationsExist && _ctx.searchValue)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("notification.emptyNoResult")), 1),
                  _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("notification.emptyNoResultDescription")), 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isNotificationsExist && !_ctx.searchValue)
              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("notification.emptyNoMessage")), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isNotificationsExist)
        ? (_openBlock(), _createBlock("div", _hoisted_15, [
            (_ctx.mainNotifications.length !== 0)
              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("notification.mainNews")), 1)
                  ]),
                  _createVNode("div", _hoisted_19, [
                    _createVNode(_component_splide, {
                      options: {
                autoplay: true,
                arrows: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                drag: true,
                focus: 'center',
                rewind: true,
                type: 'loop',
                padding: {
                  right: '5rem',
                  left: 0
                },
                classes: {
                  page:
                    'splide__pagination__page splide__pagination__page.is-active opacity-100 hover:bg-red-lp-100'
                }
              },
                      class: "w-full",
                      style: {"min-width":"267px","height":"260px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mainNotifications, (item, index) => {
                          return (_openBlock(), _createBlock(_component_splide_slide, { key: index }, {
                            default: _withCtx(() => [
                              _createVNode("div", _hoisted_20, [
                                _createVNode("div", {
                                  class: 
                      `${!item.read &&
                        'bg-gray-lp-700'} px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-start cursor-pointer w-full h-full shadow-black border border-gray-lp-400 rounded-md m-1`
                    ,
                                  onClick: ($event: any) => (_ctx.goDetail(item.id))
                                }, [
                                  _createVNode("div", _hoisted_21, [
                                    _createVNode("div", {
                                      class: 
                          `${
                            _ctx.initialNameNotification(item.createdBy).color
                          } ${!_ctx.isCollapse &&
                            'mr-2'} w-6 h-6 font-semibold text-10px items-center tracking-wider flex flex-col justify-center text-white rounded-full`
                        
                                    }, _toDisplayString(_ctx.initialNameNotification(item.createdBy).initial), 3)
                                  ]),
                                  _createVNode("div", _hoisted_22, [
                                    _createVNode("div", _hoisted_23, [
                                      _createVNode("span", _hoisted_24, _toDisplayString(item.createdBy), 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.getSharedNewsSnippet(
                            item.createdBy,
                            item.title,
                            130,
                            true
                          )), 1)
                                    ]),
                                    _createVNode("div", _hoisted_25, _toDisplayString(_ctx.formatDate(item.releasedAt)), 1),
                                    _withDirectives(_createVNode("img", {
                                      src: item.bannerImage,
                                      class: "pt-2 w-300px h-24 object-cover",
                                      alt: ""
                                    }, null, 8, ["src"]), [
                                      [_vShow, item.bannerImage]
                                    ])
                                  ])
                                ], 10, ["onClick"])
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["options"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _hoisted_26,
            _createVNode("div", _hoisted_27, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allNotifications, (e, i) => {
                return (_openBlock(), _createBlock("div", {
                  key: i,
                  class: "border-b border-gray-lp-700 py-4"
                }, [
                  _createVNode("div", _hoisted_28, _toDisplayString(i), 1),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(e, (item, index) => {
                    return (_openBlock(), _createBlock("div", { key: index }, [
                      _createVNode("div", {
                        class: 
                  `${(!item.read || item.meta.isDeviceMaster) &&
                    'bg-gray-lp-700'} ${index === _ctx.allNotifications.length - 1 &&
                    'rounded-b-md'} cursor-pointer px-6 py-4 flex flex-row items-start`
                ,
                        onClick: ($event: any) => (_ctx.goDetail(item.id, item.meta.isDeviceMaster))
                      }, [
                        _createVNode("div", _hoisted_29, [
                          _createVNode("div", {
                            class: 
                      `${
                        _ctx.initialNameNotification(item.createdBy).color
                      } ${!_ctx.isCollapse &&
                        'mr-2'} w-6 h-6 font-semibold text-10px items-center tracking-wider flex flex-col justify-center text-white rounded-full`
                    
                          }, _toDisplayString(_ctx.initialNameNotification(item.createdBy).initial), 3)
                        ]),
                        _createVNode("div", _hoisted_30, [
                          _createVNode("div", _hoisted_31, [
                            (item.meta.isDeviceMaster)
                              ? (_openBlock(), _createBlock("div", _hoisted_32, [
                                  _createVNode("p", null, [
                                    _createTextVNode(_toDisplayString(_ctx.$t("notification.loginRequest")) + " ", 1),
                                    _createVNode("b", null, _toDisplayString(_ctx.$t("notification.from")) + " " + _toDisplayString(item.meta.deviceAccountName), 1),
                                    _createVNode("span", _hoisted_33, _toDisplayString(item.meta.deviceName), 1),
                                    _createVNode("span", _hoisted_34, _toDisplayString(item.meta.deviceOs), 1)
                                  ]),
                                  _createVNode("div", _hoisted_35, [
                                    (_ctx.permissionButtonActionReject)
                                      ? (_openBlock(), _createBlock("button", {
                                          key: 0,
                                          onClick: ($event: any) => (_ctx.handleConfirmation(item.meta, 'reject')),
                                          class: "px-4 py-2 bg-red-500 rounded-md flex items-center gap-2"
                                        }, [
                                          _createVNode("div", _hoisted_36, [
                                            _createVNode(_component_Icons, {
                                              name: "close",
                                              class: "w-2.5 text-red-500 font-bold"
                                            })
                                          ]),
                                          _createVNode("span", _hoisted_37, _toDisplayString(_ctx.$t("notification.reject")), 1)
                                        ], 8, ["onClick"]))
                                      : _createCommentVNode("", true),
                                    (_ctx.permissionButtonActionApprove)
                                      ? (_openBlock(), _createBlock("button", {
                                          key: 1,
                                          onClick: ($event: any) => (_ctx.handleConfirmation(item.meta, 'approve')),
                                          class: "px-4 py-2 bg-green-500 rounded-md flex items-center gap-2"
                                        }, [
                                          _createVNode(_component_Icons, {
                                            name: "check-circle",
                                            class: "w-4 text-white"
                                          }),
                                          _createVNode("span", _hoisted_38, _toDisplayString(_ctx.$t("notification.accept")), 1)
                                        ], 8, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_39, [
                                  _createVNode("span", _hoisted_40, _toDisplayString(item.createdBy), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.getSharedNewsSnippet(item.createdBy, item.title, 130)), 1)
                                ])),
                            _createVNode("div", _hoisted_41, _toDisplayString(_ctx.dateToTime(item.releasedAt)), 1)
                          ]),
                          _withDirectives(_createVNode("img", {
                            src: item.bannerImage,
                            class: "pt-4 w-500px h-40 object-cover",
                            alt: ""
                          }, null, 8, ["src"]), [
                            [_vShow, item.bannerImage]
                          ])
                        ])
                      ], 10, ["onClick"])
                    ]))
                  }), 128))
                ]))
              }), 128)),
              _createVNode(_component_infinite_scroll, {
                getApiData: _ctx.getApiData,
                isLoading: _ctx.isLoading
              }, null, 8, ["getApiData", "isLoading"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}